<template>
  <div>
    <el-carousel :interval="5000" height="600px" arrow="always" class="carousel" indicator-position="inside">
      <el-carousel-item v-for="item in carouselList" :key="item.sequence">
        <el-row>
          <el-col :span="24">
            <div class="banner" :style="'background-image: url('+common.getPictureUrl(item)+')'">
              <div class="banner-head" >{{item.head}}</div>
              <div class="banner-box" >
                <div class="banner-wrapper">
                  <hr class="banner-line">
                  <div class="banner-en" >{{item.headEn}}</div>
                  <hr class="banner-line">
                </div>
              </div>
              <!--<div class="banner-en" >{{item.headEn}}</div>-->
              <div class="banner-subhead">{{item.subhead}}</div>
            </div>
            <img :src="common.getPictureUrl(item)" width="100%" height="600px" class="banner_img"/>

          </el-col>
        </el-row>
      </el-carousel-item>
    </el-carousel>
    <div class="product">
      <!--产品及服务-->
      <div class="tittle-cn">产品及服务</div>
      <div class="tittle-en">PRODUCTS AND SERVICES</div>
      <div class="product-content">
        <div class="product-cards">
          <div class="product-card pointer" @click="linkTO('Product')">
            <div class="pic p1">
              <!--<div class="border-circle"></div>-->
            </div>
            <!--<img src="/static/images/products.png"/>-->
            <div class="product-head">人脸识别</div>
            <div class="product-subhead">中科新创提供的能进行人脸识别认证的APP，使用户可以无门槛的实现人脸识别认证</div>
          </div>
          <div class="product-card pointer" @click="linkTO('Product')">
            <div class="pic p2">
              <!--<div class="border-circle"></div>-->
            </div>
            <div class="product-head">声纹识别</div>
            <div class="product-subhead">中科新创提供的能进行声纹识别认证的APP，用户可以直接通过声音进行认证</div>
          </div>
          <div class="product-card pointer" @click="linkTO('Product')">
            <div class="pic p3">
              <!--<div class="border-circle"></div>-->
            </div>
            <div class="product-head">指静脉识别</div>
            <div class="product-subhead">中科新创提供的能进行指静脉识别终端，具有识别度高，反应灵敏，数据安全等特点</div>
          </div>
          <div class="product-card pointer" @click="linkTO('Product')">
            <div class="pic p4">
              <!--<div class="border-circle"></div>-->
            </div>
            <div class="product-head">其他</div>
            <div class="product-subhead">更多的服务</div>
          </div>
        </div>
      </div>
    </div>
    <div class="tech">
      <div class="tittle-cn">核心技术</div>
      <div class="tittle-en">CORE TECHNOLOGY</div>
      <div class="tech-content">
        <div class="tech-cards">
          <div class="tech-card pointer" @click="linkTO('KeyTech#'+(index+1))" v-for="(item,index ) in techList">
            <div class="tech-head">{{item.head}}</div>
            <div class="tech-subhead">{{item.subhead}}</div>
            <a class="tech-a" href="#">查看更多</a>
          </div>
        </div>
      </div>
    </div>
    <div class="service">
      <div class="tittle-cn">服务领域</div>
      <div class="tittle-en">SERVICE FIELD</div>
      <div class="service-content pointer">
        <div class="service-item" @click="linkTO('ServiceCase#'+(index+1))"
             v-for="(item,index ) in serviceList"
             :style="{'background-image':'url('+common.getPictureUrl(item)+')'}">
          <div class="service-head">{{item.head}}</div>
          <div class="service-en">{{item.headEn}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NavBar",
    data(){
      return{
        common:this.$common,
        carouselList: [],
        techList: [],
        serviceList: [],
      }
    },
    mounted(){
      let self = this
      this.$nextTick(() => {
        this.loadContent('carousel');
        this.loadContent('tech');
        this.loadContent('service')
      })
    },
    methods:{
      linkTO(url){
        this.$router.push(url)
      },
      loadContent(type) {
        this.common.post('content/list',
          { 'type':type},(response)=>{
            if(type==='carousel'){
              this.carouselList = response.data.content;
            }
            if(type==='tech'){
              this.techList = response.data.content;
            }
            if(type==='service'){
              this.serviceList = response.data.content;
            }
          }
        )
      },
    },
  }
</script>

<style scoped>

  .banner-head{
    color: #3b327b;
  }

  .banner-en{
    color: #3b327b;
  }
  .pointer{
    cursor:pointer;
  }

  .product-content .pic {
    margin: 0 auto;
    width: 115px;
    height: 130px;
    background: url(../assets/Home-ProductsAndServices.png) no-repeat;
  }

  /*下面是圆形边框*/
  /*.product-content .border-circle {*/
    /*overflow: hidden;*/
    /*width: 142px;*/
    /*border: 2px solid #aaa;*/
    /*border-radius: 50%;*/
    /*height: 142px;*/
    /*position: absolute;*/
    /*left: 2px;*/
    /*top: 0;*/
    /*opacity: 1;*/
    /*transition: all 0.5s;*/
    /*clear: both;*/
  /*}*/
  /*.product-content .product-card:hover .border-circle {transform: scale(1.3);opacity: 0;}*/
  .product-content .product-card .p1{background-position: -0px -187px;}
  .product-content .product-card .p2{background-position: -300px -187px;}
  .product-content .product-card .p3{background-position: -599px -187px;}
  .product-content .product-card .p4{background-position: -899px -187px;}

  .product-content .product-card:hover .p1{background-position: -0px  -0px;}
  .product-content .product-card:hover .p2{background-position: -300px -0px;}
  .product-content .product-card:hover .p3{background-position: -599px -0px;}
  .product-content .product-card:hover .p4{background-position: -899px -0px;}

  .product-content .product-card:hover .text{color: #cf131c;}
  .product-content .text{margin-top: 25px;}
  .product-content .dsc{padding: 5px 14px 0; color: #666;}

  /***************分割线********************/
  .product-head{
    text-align: center;
    margin-top: 14px;
    color: #595757;
    font-size: 24px;
    /*clear: both;*/
  }
  .product-subhead{
    text-align: center;
    margin-top: 18px;
    color: #595757;
    font-size: 14px;
  }

  .product-card{
    width: 141px;
    float: left;
    margin: 0 auto;
  }
  .product-card:first-child{
    margin: 0 0 0 80px;
  }
  .product-card +div{
    margin: 0 0 0 166px;
  }
  .product{
    /*width: 1200px;*/
    /*background-color:#f5f5f5;*/
  }
  .tittle-cn{
    text-align: center;
    margin-top: 38px;
    color: #128ACA;
    font-size:36px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color:rgba(68,138,202,1);
    border-bottom: 1px solid rgba(170,170,170,1);
  }
  .tittle-en{
    text-align: center;
    margin-top: 5px;
    font-size:14px;
    font-family:ArialMT;
    font-weight:400;
    color:rgba(114,113,113,1);
  }
  .product-content{
    max-width: 1200px;
    height: 275px;
    margin: 58px auto 0;
  }
  .product-cards{
    /*overflow: hidden;只是为了调试的时候好看*/
    overflow: hidden;
  }
  .tech{
    margin: 55px auto 0;
  }

  .tech-content{
    margin: 28px auto 0;
    /*width:1920px;*/
    height:500px;
    background: rgba(220,220,220,0.5) url(../assets/tech-background.jpg) no-repeat ;
    background-size:100% 100%;
    position: relative;
  }
  .tech-cards{
    max-width: 1032px;
    margin: 0 auto;
  }
  .tech-card{
    width: 312px;
    height: 392px;
    float: left;
    /*overflow: hidden;*/
    margin: 61px 16px 0;
    background-color: #ffffff;
  }

  .tech-card:hover{
    color: #EEEEEE;
    background-color: rgba(68,138,202,1);
  }
  .tech-card:hover a{
    border:1px solid #EEEEEE;
  }
  .tech-head{
    width: inherit;
    margin: 47px auto 0;
    text-align: center;
    position: absolute;
    font-size:24px;
    font-family:Adobe Heiti Std R;
    font-weight:normal;
    color:inherit;
  }
  /*.tech-head::before{*/
    /*content: "0";*/
  /*}*/
  .tech-subhead{
    box-sizing: border-box;
    width: inherit;
    margin-top: 112px;
    font-size:14px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    padding: 0 36px;
    height: 204px;
    color:inherit;
  }
  .tech-a{
    display: block;
    margin: 0 auto;
    text-decoration-line: none;
    width:115px;
    height:30px;
    border:1px solid rgba(68,138,202,1);
    border-radius:10px;
    font-size:20px;
    font-family:Adobe Heiti Std R;
    font-weight:normal;
    color:inherit;
    text-align: center;

  }
  .service{
    clear:both;
  }

  .service-content{
    margin: 51px auto 0;
    width:1200px;
    height:500px;
  }

  .service-item{
    margin: 6px;
    background: no-repeat center center;
    background-size: contain;
    height: 283px;
    width:576px;
    float: left;
  }

  .service-head{
    position: relative;
    font-size: 24px;
    text-align: center;
    color: #FFFFFF;
    top:45%;
  }
  .service-en{
    text-transform:uppercase;
    position: relative;
    font-size: 14px;
    text-align: center;
    color: #FFFFFF;
    top:45%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue